// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kJc9","top":"styles_top__2jzTd"};